import ActionsForm from '@/shared/mixins/actionsForm'
import AutocompleteZ from '@/components/forms/AutocompleteZ'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpenses/mixins/ExpenseMixin.js'
import searchReports from './components/searchReports/searchReports.vue'
import chartReports from './components/chartReports/chartReports.vue'

export default {
  name: 'Reports',
  mixins: [ActionsForm, ExpenseMixin],
  components: {AutocompleteZ, searchReports, chartReports},
  data () {
    return {
      formSearch: {},
      contapatologia: 0
    }
  },
  methods: { }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/reports/reports.js